var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("authority", {
    attrs: {
      type: "role",
      id: this.$route.params.id
    },
    on: {
      ok: _vm.handleOk
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };